import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/28_card_back_toucan/28_card_back_toucan"
 * Contains 1 texture(s)
 */
export class CardsBacks28CardBackToucanAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/28_card_back_toucan/28_card_back_toucan';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '28_toucan.png'
    ] as const;
}
